import * as React from 'react';

import get from 'lodash/get';

import {Routing} from 'nutshell-core/routing';
import type {FilterObject} from 'nutshell-core/types';

import {FilterCapsule} from 'shells/filter-capsule/filter-capsule';
import {Radio} from 'shells/radio/radio';
import {RadioGroupSlider} from 'shells/radio/radio-group-slider';

import styles from './leaderboard-form.module.css';

const leaderboardFilters = {
    sales: [
        {
            name: 'dashboardPeriod',
            key: 'period',
            defaultValue: 'mtd',
            defaultValueTitle: 'Date range: Month-to-date',
        },
        {
            name: 'owner',
            key: 'filter.owner',
            defaultValue: undefined,
            defaultValueTitle: undefined,
        },
        {
            name: 'tags',
            key: 'filter.tags',
            defaultValue: undefined,
            defaultValueTitle: undefined,
        },
    ],
    activities: [
        {
            name: 'dashboardPeriod',
            key: 'period',
            defaultValue: 'mtd',
            defaultValueTitle: 'Date range: Month-to-date',
        },
        {
            name: 'participant',
            key: 'filter.participant',
            defaultValue: undefined,
            defaultValueTitle: undefined,
        },
        {
            name: 'activityType',
            key: 'filter.activityType',
            defaultValue: undefined,
            defaultValueTitle: undefined,
        },
    ],
} as const;

type Props = {
    value: string;
    schema: any;
    onFilterSubmit: (data: FilterObject, key: string) => void;
    onFilterRemove: (filterKey: string) => void;
    onFormFieldChange: (key: string, newValue: string) => void;
};

type FormValues = {
    type: 'sales' | 'activities';
};

export class LeaderboardForm extends React.Component<Props> {
    render() {
        const formValues: FormValues = Routing.deparam(this.props.value);

        return (
            <div className={styles.container}>
                <div className={styles['top-container']}>
                    <div className={styles['type-container']}>
                        <div className={styles.label}>Type</div>
                        <RadioGroupSlider
                            name='leaderboardType'
                            size='big'
                            selectedValue={formValues.type}
                            selectedIndex={formValues.type === 'sales' ? 0 : 1}
                            onChange={(data: string) => this.props.onFormFieldChange('type', data)}
                        >
                            <Radio value='sales'>Sales</Radio>
                            <Radio value='activities'>Activities</Radio>
                        </RadioGroupSlider>
                    </div>
                </div>
                <div className={styles.label}>Filters</div>
                <div className={styles['selectable-filters']}>
                    {leaderboardFilters[formValues.type].map((filter) => {
                        return (
                            <FilterCapsule
                                key={filter.key}
                                filter={get(formValues, filter.key)}
                                filterName={filter.name}
                                schemaField={this.props.schema[filter.name]}
                                // @ts-expect-error
                                defaultValue={filter.defaultValue}
                                defaultValueTitle={filter.defaultValueTitle}
                                onSubmit={(data: FilterObject) =>
                                    this.props.onFilterSubmit(data, filter.key)
                                }
                                onUpdate={(data: FilterObject) =>
                                    this.props.onFilterSubmit(data, filter.key)
                                }
                                onRemove={() => this.props.onFilterRemove(filter.key)}
                            />
                        );
                    })}
                </div>
            </div>
        );
    }
}
